export const UPDATE_TOKEN = 'UPDATE_TOKEN';
export const TOGGLE_THEME = 'TOGGLE_THEME';
export const UPDATE_SELECTED_TAB = 'UPDATE_SELECTED_TAB';
export const UPDATE_CURRENT_LINEITEM = 'UPDATE_CURRENT_LINEITEM';
export const UPDATE_LAST_LINEITEM = 'UPDATE_LAST_LINEITEM';
export const UPDATE_PART_VALIDATION = 'UPDATE_PART_VALIDATION';
export const UPDATE_PROCESS_VALIDATION = 'UPDATE_PROCESS_VALIDATION';
export const UPDATE_OPERATIONS = 'UPDATE_OPERATIONS';
export const UPDATE_RECEIVE_PART = 'UPDATE_RECEIVE_PART';
export const UPDATE_SCAN_ATTRIBUTE = 'UPDATE_SCAN_ATTRIBUTE';
export const UPDATE_TABLE_FILTER = 'UPDATE_TABLE_FILTER';
export const RESET_TABLE_FILTER = 'RESET_TABLE_FILTER';
export const UPDATE_SELECTED_COLUMNS = 'UPDATE_SELECTED_COLUMNS';
export const UPDATE_MODE_TYPE = 'UPDATE_MODE_TYPE';
export const GROUPLEADERCRED = 'GROUPLEADERCRED';
export const UPDATE_RECEIVE_TS = 'UPDATE_RECEIVE_TS';